<template>
  <div
    v-if="parceiro"
    class="q-ml-sm text-brand-5 text-weight-bold titulo-input"
  >
    {{ label }}
  </div>
  <q-select
    dense
    v-if="parceiro"
    v-model="model"
    use-input
    hide-selected
    fill-input
    outlined
    class="select-btn"
    input-debounce="0"
    :options="options"
    @filter="filterFn"
  >
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey"> Sem resultados </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  props: ["unidade", "parceiro", "label"],
  setup(props, { emit }) {
    const store = useStore();
    const options = ref([]);

    let model = ref(null);

    const getData = async (parceiroId) => {
      options.value = [];
      try {
        let resposta = await store.dispatch("pdt/getFuncionariosTerceiros", {
          busca: parceiroId,
          unidadeId: props.unidadeId,
        });

        let i = -1;

        resposta.data.resultado.dados.forEach((e) => {
          i++;
          options.value[i] = `${e.nome} - ${e.matricula}`;
        });
      } catch (error) {
        console.log(error);
      }
    };

    watch(model, () => {
      emit("selectValue", model.value);
    });

    watch(
      () => props.parceiro,
      () => {
        model.value = "";
        let parceiroId = props.parceiro.split("-")[0];

        getData(parceiroId);
      }
    );

    return {
      options,
      filterFn(val, update) {
        update(() => {
          const needle = val.toLowerCase();
          options.value = options.value.filter(
            (v) => v.toLowerCase().indexOf(needle) > -1
          );
        });
      },
      getData,
      model,
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .titulo-input {
    font-size: 11px !important;
    margin: 0px;
  }
  .select-btn {
    font-size: 10px !important;
  }
}
</style>
